import React from "react";
import styled from "styled-components";

import RightPanel from "../components/fragments/RightPanel";

export default function Contact() {
  return <RightPanel>Contact</RightPanel>;
}
